<template>
    <!-- Start Blog Area -->
    <section class="blog-area ptb-80">
        <div class="container">
            <div class="section-title">
                <h2>The News from Our Blog</h2>
                <div class="bar"></div>
                <p>Working with us you can lift the web reputation of your company higher than ever. We can offer you all the advantages of modern digital marketing services in Bangladesh. </p>
            </div>

            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-post">
                        <div class="blog-image">
                            <a href="#">
                                <img src="../../../assets/img/blog-image/1.jpg" alt="image">
                            </a>

                            <div class="date">
                                <feather type="calendar"></feather> March 15, 2021
                            </div>
                        </div>

                        <div class="blog-post-content">
                            <h3><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h3>

                            <span>by <a href="#">WB-Software</a></span>

                            <p>In today's world everybody has a smartphone and a business owner like you can take advantage of this by creating an app for your business. An app is a very good way to cultivate customer loyalty as it gives you and your customer a genuine way to communicate directly.</p>

                            <router-link to="/blog-details/NeedWebSide" class="read-more-btn">Read More <feather type="arrow-right"></feather> </router-link>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="single-blog-post">
                        <div class="blog-image">
                            <a href="#">
                                <img src="../../../assets/img/blog-image/2.jpg" alt="image">
                            </a>

                            <div class="date">
                                <feather type="calendar"></feather> March 17, 2021
                            </div>
                        </div>

                        <div class="blog-post-content">
                            <h3><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h3>

                            <span>by <a href="#">WB-Software</a></span>

                            <p>Over 90% of people have access to the internet and what you need is a website to reach them all. A website will prove your brand credibility. over 30% of people don't consider a business if it does not have any website. So if you want your customer to think that your business is...</p>

                            <router-link to="/blog-details/NeedApps" class="read-more-btn">Read More <feather type="arrow-right"></feather> </router-link>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                    <div class="single-blog-post">
                        <div class="blog-image">
                            <a href="#">
                                <img src="../../../assets/img/blog-image/4.jpg" alt="image">
                            </a>

                            <div class="date">
                                <feather type="calendar"></feather> March 19, 2021
                            </div>
                        </div>

                        <div class="blog-post-content">
                            <h3><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h3>

                            <span>by <a href="#">WB-Software</a></span>

                            <p>Each business has a different set of goals to reach, but the main among them is always reach. Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing. It is the most affordable means of...</p>

                            <router-link to="/blog-details/NeedDigitalMarketing" class="read-more-btn">Read More <feather type="arrow-right"></feather> </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Blog Area -->
</template>

<script>
export default {
    name: 'Blog'
}
</script>